import * as layout from '../../layout'
import { BrandingGuideDelegate } from '../types'
import ComponentBranding from './ComponentBranding'

export default class ProgressBarBranding extends ComponentBranding {

  constructor(
    delegate: BrandingGuideDelegate,
    parent: ProgressBarBranding | null,
  ) {
    super(delegate,parent, {
      shape:       {rounded: layout.radius.s},
      background:  'dimmer',
      border:      'none',
      depth:       0,
      previewSize: {width: 160, height: 20},
    })
  }

  public inner = new ComponentBranding(this, null, {
    shape:      'rectangle',
    background: 'solid',
    border:     'none',
    depth:      0,
    previewSize: {width: 160, height: 20},
  })

}